(() => {
  // Feather the actual responsive arc, rather than the far edge of the full slide.
  document.querySelectorAll('.shg-stockie-curve').forEach(curve => {
    const rim=document.createElement('span');
    rim.className='shg-glass-rim';
    rim.setAttribute('aria-hidden','true');
    curve.append(rim);
    const update=()=>{
      const {width:w,height:h}=curve.getBoundingClientRect();
      if(!w||!h)return;
      const x=w*.55, feather=1;
      const svg=`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}"><defs><filter id="edge" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur stdDeviation="${feather}"/></filter></defs><path fill="white" filter="url(#edge)" d="M -100 -100 H ${x+h*.12} V 0 C ${x-h*.08} ${h/3} ${x-h*.08} ${h*2/3} ${x+h*.23} ${h} V ${h+100} H -100 Z"/></svg>`;
      curve.style.setProperty('--shg-glass-mask',`url("data:image/svg+xml,${encodeURIComponent(svg)}")`);
      // Follow the same arc: a narrow bevel, not a new panel boundary.
      const arc=`M ${x+h*.12} 0 C ${x-h*.08} ${h/3} ${x-h*.08} ${h*2/3} ${x+h*.23} ${h}`;
      const edge=`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}"><defs><linearGradient id="light" x1="0" y1="0" x2="0" y2="1"><stop stop-color="white" stop-opacity=".65"/><stop offset=".5" stop-color="white" stop-opacity=".22"/><stop offset="1" stop-color="white" stop-opacity=".55"/></linearGradient></defs><g fill="none"><path d="${arc}" stroke="#58636c" stroke-opacity=".16" stroke-width="2"/><path d="${arc}" stroke="url(#light)" stroke-width="1.2"/><path d="${arc}" transform="translate(-.6 0)" stroke="white" stroke-opacity=".6" stroke-width=".5"/></g></svg>`;
      rim.style.backgroundImage=`url("data:image/svg+xml,${encodeURIComponent(edge)}")`;
      curve.classList.add('has-glass-mask');
    };
    new ResizeObserver(update).observe(curve);
    update();
  });
})();
